// extracted by mini-css-extract-plugin
module.exports = {"photosGrid":"PhotosGrid-module--photosGrid--3YaLC","photosGridTitle":"PhotosGrid-module--photosGridTitle--2XlHs","photosGridPhoto":"PhotosGrid-module--photosGridPhoto--2Hr-h"};